
























































































import { Component, Vue, Watch } from 'vue-property-decorator';

import { repoLink } from '@/constants/links';

@Component({
	name: 'App'
})
export default class App extends Vue {
	repoLink: string = repoLink;

	created() {
		this.$Progress.start();
		this.$router.beforeEach((to, from, next) => {
			this.$Progress.start();
			next();
		});
		this.$router.afterEach(() => {
			this.$Progress.finish();
		});
	}
	mounted() {
		this.$Progress.finish();
	}
}
